/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionOut } from './TransactionOut';
import {
    TransactionOutFromJSON,
    TransactionOutFromJSONTyped,
    TransactionOutToJSON,
} from './TransactionOut';

/**
 * 
 * @export
 * @interface MoneyOutOutput
 */
export interface MoneyOutOutput {
    /**
     * 
     * @type {TransactionOut}
     * @memberof MoneyOutOutput
     */
    transaction?: TransactionOut;
    /**
     * 
     * @type {Error}
     * @memberof MoneyOutOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyOutOutput interface.
 */
export function instanceOfMoneyOutOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyOutOutputFromJSON(json: any): MoneyOutOutput {
    return MoneyOutOutputFromJSONTyped(json, false);
}

export function MoneyOutOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyOutOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transaction': !exists(json, 'transaction') ? undefined : TransactionOutFromJSON(json['transaction']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyOutOutputToJSON(value?: MoneyOutOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction': TransactionOutToJSON(value.transaction),
        'error': value.error,
    };
}

